import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../../../components/Header';
import LanguageSelector from '../../components/LanguageSelector';
import ProgressBar from './ProgressBar';
import PageQuestionsList from './PageQuestionsList';
import SurveyNav from './SurveyNav';

const Survey = () => {
  const { t } = useTranslation('commons');
  return (
    <Fragment>
      <Header>
        <LanguageSelector />
        <ProgressBar />
      </Header>
      <div className="container mt-4 mb-4">
        <div className="row">
          <div className="col-lg-7">
            <h5>{t('surveyHeader')}</h5>
            <PageQuestionsList />
            <SurveyNav />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Survey;
